import React, { FC } from 'react';
import classnames from 'classnames';

import CustomLabel from '../CustomLabel';
import Icon, { IconmoonFont } from 'vibo-ui/Icon';

import { CustomLabelProps, CustomLabelTypes } from '../CustomLabel/interfaces';

const DefaultLabel: FC<CustomLabelProps> = ({ ...rest }) => (
  <CustomLabel
    {...rest}
    type={CustomLabelTypes.gray}
    className={classnames('defaultLabel', rest.className)}
  >
    <Icon icon={IconmoonFont['templates-16']} />
    Default
  </CustomLabel>
);

export default DefaultLabel;
